/* unplugin-vue-components disabled */import { render } from "./demo.vue?vue&type=template&id=7b247b90&scoped=true"
import script from "./demo.vue?vue&type=script&lang=js"
export * from "./demo.vue?vue&type=script&lang=js"

import "./demo.vue?vue&type=style&index=0&id=7b247b90&lang=less&scoped=true"

import exportComponent from "D:\\云盘\\SynologyDrive\\Synology Drive\\文件\\客户调查表\\customweb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b247b90"]])

export default __exports__